export default __webpack_public_path__ + "static/eko-9f0e8354c49c647e07dc2950d46f86f2.jpg";